'use strict';

var addProductToCart = require('./product/addToCart'),
    page = require('../page'),
    login = require('../login'),
    util = require('../util'),
    ajax = require('../ajax'),
    quickview = require('../quickview'),
    dialog = require('../dialog'),
    validator = require('../validator'),
	progress = require('../progress'),
	account = require('./account'),
	tealium = require('../../../../int_tealium/cartridge/js/tealium/tealium');

exports.init = function () {
	util.secondaryNavigationActiveInactiveStates('secondary-navigation-links');
    addProductToCart();
    $('#editAddress').on('change', function () {
        page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
    });

    //add js logic to remove the , from the qty feild to pass regex expression on client side
    $('.option-quantity-desired input').on('focusout', function () {
        $(this).val($(this).val().replace(',', ''));
    });
    
    $('.share-icon-container').find('.share-wishlist').on('click', function (e) {
        e.preventDefault();
        var ResourceMessage;
        if ($(window).width() > 767) {
        	ResourceMessage = Resources.SHARE_EMAIL;
        } else {
        	ResourceMessage = Resources.SHARE_EMAIL_MOBILE;
        }
        dialog.open({
            url: $(this).attr('href'),
            options: {
            	dialogClass: 'wishlist-email',
            	title : ResourceMessage,
            	width: 760,
            	open: function() {
            		validator.init();
            		util.sendGiftMessageCharCount();
            		multiEmails();
            		recipientsEmailLabel();
            		//closing on overlay click
                	$('.ui-widget-overlay').on('click',function(e){
                		if($('.wishlist-email').is(':visible')) {
                			$('.wishlist-email').find('.ui-dialog-titlebar-close').trigger('click');
                		}
                	});
                	/* PXSFCC-4495_WCAG_Modal_focus_management */
                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                    	$(this).focus();
                    });
                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
            	}
            }
        });
    });
    
    $("body").on('click','.edit-wishlist-detail a',function (e) {
    	if($(window).width() > 1023) {
    		e.preventDefault();
    		 quickview.show({
                 url: $(this).attr('href'),
                 source: 'wishlist',
                 callback: function() {
                     //closes QV modal on overlay click
                     $('.ui-widget-overlay').bind('click', function() { 
                         $('#QuickViewDialog').dialog('close');
                     });
                 } 
             }); 
    	 }
    });
    
	
	$(window).on('load', function () {
		var pids = [];
		$('.item-list .wishlist-row').each(function(){
			pids.push($(this).data('itemid'));
		});

		var obj = {
			event_name : "wishlist_item_ids",
			wishlist_item_ids : pids
		}
		tealium.triggerEvent(obj);
		
	});
	
    $(document).on('click','.item-list .option-toggle-public .input-checkbox', function(e) {
    	e.preventDefault();
    	var $this = $(this),
    		$currentObj = $this.closest('.item-dashboard'),
    		form = $this.closest('form'),
    		loader;
    	if(form.find('input[type="hidden"]').hasClass('wishlist-hidden')) {
    		form.find('.wishlist-hidden').remove();
    	}
        $('<input type="hidden" name="' + $this.closest('.item-dashboard').find("button[value='Update']").attr('name') + '" value="true" class="wishlist-hidden" />').appendTo(form);
        if ($(window).width() < 768) {
        	loader = $this.closest('.wishlist-row');
        } else {
        	loader = $currentObj;
        }
        progress.show(loader);
        ajax.load({
            url: form.attr('action'),
            data: form.serialize(),
            method: 'POST',
            callback: function (data) {
            	$currentObj.find('.public-item').empty();
            	$currentObj.find('.public-item').html(data);
            	progress.hide();
            }
        });
	});
	
	$('body').on('submit','form.wishlist-search', function(){
		var $firstName = $(this).find('input.firstname_wishlist');
		var $email = $(this).find('input.email_wishlist');
		if(!$firstName.val().length && !$email.val().length){
			$(this).addClass('make-label-absolute');
			$firstName.attr('data-required-text', $firstName.closest('.form-row').find('span.label-text').text()).siblings('.error').remove();
			$email.attr('data-required-text', $email.closest('.form-row').find('span.label-text').text()).siblings('.error').remove();
			var formvalidator = $('form.wishlist-search').validate(validator.settings);
			$firstName.rules("add",{ required: true });
			$email.rules("add",{ required: true });
			formvalidator.element($firstName);
			formvalidator.element($email);
			return false;
		}
		else{
			return true;
		}
	});

	$('body').on('keyup','form.wishlist-search input:not(:button)', function(e){
		if(e.keyCode !== 13){
			$(this).closest('form').removeClass('make-label-absolute');
			$(this).closest('form').find('input.email_wishlist, input.firstname_wishlist').each(function(){
				if($(this).closest('.form-row').find('label').find('span.error').length){
					$(this).closest('.form-row').removeClass('error-handle').find('label').find('span.error').remove();
				}
				$(this).removeAttr('required').rules("add",{ required: false });
			});
			$('form.wishlist-search').validate(validator.settings);
		}
	});

    function multiEmails() {
    	$('.input-textarea.multipleemails').keyup(function () {
    		var $length = $('.multipleemails').val().length,
    			$windowLength,
    			$scrollHeight;
    		if($(window).width() >= 768){
    			$windowLength = $length >= 188;
    			$scrollHeight = '50px';
    		} else if($(window).width() <= 767){
    			$windowLength = $length >= 80;
    			$scrollHeight = '87px';
    		}
    	    if($windowLength) {
    	    	$(this).closest('.form-row').find('.label-text').hide();
    	    	$('.multipleemails').slimScroll({
	                height: $scrollHeight,
	                railVisible: true,
	                color: "#8f8f8f",
	                railColor: "#e9e9e9",
	                distance: '9px',
	                alwaysVisible: true
	            });
    	    	$('.multipleemails').focus();
    	    } else {
    	    	$(this).closest('.form-row').find('.label-text').show();
    	    	$(".multipleemails").slimScroll({destroy: true});
    	    	$('.multipleemails').focus();
    	    }
    	});
    }
    
    function recipientsEmailLabel() {
    	if($(window).width() <= 767){
		    $('.recipientsemail .label-text').text(function(){
				$(this).text('Recipients Email Address (comma if multiple)');
			});
    	}
    }
    
    util.createAccount();
    util.swapDiv();
    util.copyClipboard();
    login.init();
	account.init();
};
